export default "__VITE_ASSET__Bgqy8NJb__"